module.exports = __webpack_public_path__ + "static/media/smile.7c1138b0.svg";